import React from 'react'
import { createPortal } from 'react-dom'
import { observer } from 'mobx-react-lite'
import { useFiltersPanel } from './hooks/useFiltersPanel'
import s from './styles/FiltersPanel.module.scss'

export const FiltersPanel = observer(
	({ isOpen, onClose, children, desktopMinWidth = 1024, className = '' }) => {
		const { isDesktop } = useFiltersPanel({ desktopMinWidth })

		if (isDesktop) {
			return (
				<aside className={`${s.sidebar} ${isOpen ? s.open : ''} ${className}`}>
					<div className={s.wrap}>
						<div className={s.inner}>{children}</div>
					</div>
				</aside>
			)
		}

		if (!isOpen) return null

		return createPortal(
			<div className={s.mobileOverlay} role="dialog" aria-modal="true">
				<div className={s.mobileBackdrop} onMouseDown={onClose} />
				<div className={s.mobileSheet}>{children}</div>
			</div>,
			document.body
		)
	}
)
